<div flexLayout="column">
  <mat-toolbar color="">
    <div class="hamburger">
      <button mat-icon-button (click)="toggleGnb()">
        <mat-icon>menu</mat-icon>
      </button>
      <span style="vertical-align:middle;margin-top:10px;">
        <!--TYM. VAN-->
        <img src="../../assets/image/toplogo.png">
      </span>
      <span class="toolbar-spacer"></span>
    </div>
    <!-- <input type="text" appearance="outline">
  <button mat-icon-button>
    <mat-icon>search</mat-icon>
  </button> -->
    <!-- Login / Logout -->
    <!-- Sign in/out-->
    <div *ngIf="!currentUser$ | async">
      <button mat-button [routerLink]="['/account/log-in']">
        <mat-icon>login</mat-icon>
        Login
      </button>
    </div>

    <div *ngIf="currentUser$ | async" style="margin-left: auto; display:flex; ">

      <div style="float: left; margin-top: 8px;">
        <a href="https://www.audit-tym.world/" target="_blank">
          <img src="../../assets/image/audit.png" style="height:55px;">
        </a>
      </div>

      <button mat-button role="listitem" [routerLink]="['/admin/user']">
        <mat-icon>supervised_user_circle</mat-icon>
        사용자 정보변경
      </button>

      <button mat-button [routerLink]="['/account/log-in']">
        Logout
        <mat-icon>logout</mat-icon>
      </button>

    </div>

    <mat-progress-bar *ngIf="isBusy" color="primary" mode="indeterminate"></mat-progress-bar> <!--*ngIf="isBusy" color="primary"-->
  </mat-toolbar>
</div>

<mat-sidenav-container class="container" flexLayout="row" fxFlex>
  <mat-sidenav class="gnb" mode="side" [opened]="opened" fxFlex="20">
    <!-- Logo? -->
    <!--<div class="logo">
    <img src="https://vandev.tym.world/assets/image/tym_logo.svg">
  </div>-->
    <app-gnb></app-gnb>

    <!-- SideNavGnb Footer -->
    <!-- <div class="bottom full-width">
    <mat-selection-list role="list" [multiple]="false">
      <mat-divider></mat-divider>
      <mat-list-option role="listitem">
        <span>
          <button mat-button (click)="toggleGnb()">
            메뉴 닫기<mat-icon style="transform: rotate(180deg)">double_arrow</mat-icon>
          </button>
        </span>
      </mat-list-option>
    </mat-selection-list>
  </div> -->
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content fxFlex="80">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Footer -->
<!-- <div class="footer mat-typography" flexLayout="column">
  Powered by mazelone @2021.
</div> -->
